import React from 'react';

// Hand-authored inline SVG (no external assets, CSP-safe); fill/stroke use currentColor for per-type tint.
const MiniDoc = ({ variant = 'card', band = false, face = 'front', size = 40, title, ...rest }) => {
	if (variant === 'booklet') {
		return (
			<svg data-testid="minidoc" data-variant="booklet" width={size} height={Math.round((size * 30) / 32)} viewBox="0 0 32 30" fill="none" role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} {...rest}>
				{title && <title>{title}</title>}
				<rect x="1" y="2" width="30" height="26" rx="2" stroke="currentColor" strokeWidth="1.5" />
				<line x1="16" y1="2" x2="16" y2="28" stroke="currentColor" strokeWidth="1.5" />
				<rect x="4" y="7" width="8" height="9" rx="1" fill="currentColor" opacity="0.25" />
				<circle cx="24" cy="11" r="3" stroke="currentColor" strokeWidth="1.2" />
				<line x1="20" y1="19" x2="28" y2="19" stroke="currentColor" strokeWidth="1.2" />
			</svg>
		);
	}
	const isBack = face === 'back';
	return (
		<svg data-testid="minidoc" data-variant="card" width={size} height={Math.round((size * 28) / 44)} viewBox="0 0 44 28" fill="none" role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} {...rest}>
			{title && <title>{title}</title>}
			<rect x="1" y="1" width="42" height="26" rx="3" stroke="currentColor" strokeWidth="1.5" />
			{!isBack && <rect x="4" y="6" width="10" height="14" rx="1.5" fill="currentColor" opacity="0.25" />}
			{isBack ? (
				<>
					<line x1="6" y1="16" x2="38" y2="16" stroke="currentColor" strokeWidth="1.2" />
					<line x1="6" y1="20" x2="38" y2="20" stroke="currentColor" strokeWidth="1.2" />
					<line x1="6" y1="24" x2="30" y2="24" stroke="currentColor" strokeWidth="1.2" />
				</>
			) : (
				<>
					<line x1="18" y1="9" x2="38" y2="9" stroke="currentColor" strokeWidth="1.5" />
					<line x1="18" y1="14" x2="33" y2="14" stroke="currentColor" strokeWidth="1.5" />
					<rect x="30" y="18" width="8" height="6" rx="1" fill="currentColor" opacity="0.4" />
				</>
			)}
			{band && <rect data-testid="minidoc-band" x="39" y="1" width="4" height="26" fill="currentColor" opacity="0.6" />}
		</svg>
	);
};

export default MiniDoc;
